import React from 'react';
import Container from '../../common/components/UI/Container';
import { Image } from 'antd';
import Heading from '../../common/components/Heading';
import Text from '../../common/components/Text';
import Section, { SectionHeading, Grid, Item } from './association.style';

import { association } from '../../common/data/SaasClassic';

const Association = () => {
  return (
    <Section id="how-to">
      <Container width="1400px">
        <SectionHeading>
          <Heading content="Our Association" />
        </SectionHeading>
        <Grid>
          { association.map( ( howTo ) => (
            <Item key={ howTo.id }>
              <figure>
                <Image src={ howTo.icon } alt="icon" preview={ false } />
              </figure>
            </Item>
          ) ) }
        </Grid>
      </Container>
    </Section>
  );
};

export default Association;
